import { useRef } from '../lib/teact/teact';

import useForceUpdate from './useForceUpdate';
import useLastCallback from './useLastCallback';

// Track object-URLs that fail to load — e.g. a Blob URL the media cache revoked while an `<img>` still
// pointed at it (common in the sticker/GIF pickers, which hold many small preview blobs). Hiding the
// element on error shows nothing instead of the browser's broken-image icon; a freshly fetched URL is a
// different string, so it renders normally and no reset is needed.
export default function useBrokenMediaSrc(src: string | undefined) {
  const brokenRef = useRef<Set<string>>();
  brokenRef.current ??= new Set();
  const forceUpdate = useForceUpdate();

  const isBroken = typeof src === 'string' && brokenRef.current.has(src);

  const markBroken = useLastCallback(() => {
    if (typeof src !== 'string' || brokenRef.current!.has(src)) return;
    brokenRef.current!.add(src);
    forceUpdate();
  });

  return [isBroken, markBroken] as const;
}
